<template>
  <main>
    <div class="screen">
      <div class="fav-list">
        <div v-if="favorites && favorites.length !== 0">
          <div class="fav-cell-wrapper" v-for="(favorite, index) in favorites" :key="index">
            <favorite-card :favorite="favorite"/>
          </div>
        </div>
        <div v-else>
          <div class="textbox">
            <div class="inner">
              <h3>Favorieten?</h3>
              <p>Tap bij je<br>favoriete route<br>op het &nbsp;<svg data-v-b79c7b3c="" width="14" height="12" xmlns="http://www.w3.org/2000/svg"><path data-v-b79c7b3c="" d="M12.442 1.1c-1.556-1.467-4.08-1.467-5.637 0-1.557-1.467-4.08-1.467-5.637 0-1.557 1.467-1.557 3.844 0 5.31l5.637 5.312 5.637-5.311C14 4.944 14 2.567 12.442 1.1" fill="#FFF" fill-rule="evenodd"></path></svg></p>
            </div>
          </div><!-- /.textbox -->
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import FavoriteCard from '@/components/FavoriteCard.vue'

export default {
  components: {
    FavoriteCard
  },
  computed: {
    ...mapState({
      stops: state => state.stops,
      user: state => state.user
    }),
    favorites() {
      return this.user && this.user.favorites
    }
  },
}
</script>

<style lang="scss" scoped>
  .screen {
    padding: 0 5vw 100px 5vw;
  }

  .textbox {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    justify-content: center;
    align-items: center;

    .inner {
      padding: 0 20px;
    }

    h3,p {
      text-align: center;
    }

    p {
      line-height: 22px;
    }
  }

  h4 {
    padding-top: 200px;
    text-align: center;
  }
</style>
